import moment from "moment";

export const GENERO_OPTIONS = [
    { value: "M", label: "Masculino" },
    { value: "F", label: "Femenino" },
];

export const STATUS_OPTIONS = [
    { value: "D", label: "Disponible" },
    { value: "N", label: "No disponible" },
];

export const EMPLEADO_ROL_OPTIONS = [
    { value: "MA", label: "Administrador" },
    { value: "MP", label: "Recepción" },
    { value: "MN", label: "Limpieza" },
    { value: "MG", label: "Servicio de habitación" },
    { value: "MI", label: "Mantenimiento" },
];

export const EMPLEADO_ROL_LABELS = EMPLEADO_ROL_OPTIONS.reduce((acc, { value, label }) => {
    acc[value] = label;
    return acc;
}, {});

export const GENERO_FILTER_ALL = "all";
export const GENERO_FILTER_OPTIONS = [
    { value: GENERO_FILTER_ALL, label: "Todas" },
    ...GENERO_OPTIONS,
];

export const STATUS_FILTER_ALL = "all";
export const STATUS_FILTER_OPTIONS = [
    { value: STATUS_FILTER_ALL, label: "Todas" },
    ...STATUS_OPTIONS,
];

export const GENERO_LABELS = GENERO_OPTIONS.reduce((acc, { value, label }) => {
    acc[value] = label;
    return acc;
}, {});

export const STATUS_LABELS = STATUS_OPTIONS.reduce((acc, { value, label }) => {
    acc[value] = label;
    return acc;
}, {});

export const HOTEL_STATUS_OPTIONS = [
    { value: "A", label: "Activo" },
    { value: "B", label: "Baja" },
    { value: "S", label: "Suspendido" },
];

export const HOTEL_STATUS_LABELS = HOTEL_STATUS_OPTIONS.reduce(
    (acc, { value, label }) => {
        acc[value] = label;
        return acc;
    },
    {}
);

export const RESERVA_STATUS_OPTIONS = [
    { value: "I", label: "Check-in" },
    { value: "O", label: "Check-out" },
    { value: "C", label: "Cancelada" },
    { value: "R", label: "Reservada" },
];

export const RESERVA_STATUS_LABELS = RESERVA_STATUS_OPTIONS.reduce(
    (acc, { value, label }) => {
        acc[value] = label;
        return acc;
    },
    {}
);

export const RESERVA_STATUS_FILTER_ALL = "all";

export const RESERVA_STATUS_FILTER_OPTIONS = [
    { value: RESERVA_STATUS_FILTER_ALL, label: "Todos" },
    ...RESERVA_STATUS_OPTIONS,
];

/** Colores para la matriz de ocupación (fondo / texto) */
export const RESERVA_STATUS_COLORS = {
    R: { bg: "#E3F2FD", color: "#1565C0", border: "#90CAF9" },
    I: { bg: "#E8F5E9", color: "#2E7D32", border: "#A5D6A7" },
    O: { bg: "#F3E5F5", color: "#6A1B9A", border: "#CE93D8" },
    C: { bg: "#FFEBEE", color: "#C62828", border: "#EF9A9A" },
};

export const formatDateOnly = (value) => {
    if (value == null || value === "") return "";
    const str = String(value).trim();
    const parsed = moment(str, [
        moment.ISO_8601,
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD",
    ]);
    if (parsed.isValid()) return parsed.format("DD/MM/YYYY");
    if (str.length >= 10 && str[4] === "") {
        return `${str.substring(8, 10)}/${str.substring(5, 7)}/${str.substring(0, 4)}`;
    }
    return str;
};

export const formatNullableDateOnly = (value) => {
    if (value == null || value === "") return "";
    const formatted = formatDateOnly(value);
    return formatted || "";
};

export const formatDateTime = (value) => {
    if (value == null || value === "") return "";
    const str = String(value).trim();
    const hasTime = /[T ]\d{1,2}:\d{2}/.test(str) || str.length > 10;
    const parsed = moment(str, [
        moment.ISO_8601,
        "YYYY-MM-DDTHH:mm:ss",
        "YYYY-MM-DD HH:mm:ss",
        "YYYY-MM-DD",
    ]);
    if (parsed.isValid()) {
        return hasTime
            ? parsed.format("DD/MM/YYYY HH:mm")
            : parsed.format("DD/MM/YYYY");
    }
    if (str.length > 10) {
        return moment.utc(str, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY HH:mm");
    }
    return formatDateOnly(value);
};

export const formatNullableDateTime = (value) => {
    if (value == null || value === "") return "";
    const formatted = formatDateTime(value);
    return formatted || "";
};

export const formatTimeOnly = (value) => {
    if (value == null || value === "") return "";
    const str = String(value).trim();
    const parsed = moment(
        str,
        ["HH:mm:ss", "HH:mm", "YYYY-MM-DDTHH:mm:ss", "YYYY-MM-DD HH:mm:ss"],
        true
    );
    if (parsed.isValid()) return parsed.format("HH:mm");
    const timeMatch = str.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
    if (timeMatch) {
        return `${timeMatch[1].padStart(2, "0")}:${timeMatch[2]}`;
    }
    return "";
};

export const formatNullableTimeOnly = (value) => {
    if (value == null || value === "") return "";
    const formatted = formatTimeOnly(value);
    return formatted || "";
};

export const formatReservaStatus = (value) => {
    if (value == null || value === "") return "";
    const code = String(value).trim().toUpperCase();
    return RESERVA_STATUS_LABELS[code] ?? code;
};
